import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  BoxCard: {
    display: 'flex',
    padding: '24px',
    alignItems: 'center',
    flexDirection: 'column',
    gap: '12px',
    flexShrink: 0,
    borderRadius: '12px',
    border: '1px solid var(--Gray-200, #EAECF0)',
    background: 'var(--Base-White, #FFF)',
    boxShadow: '0px 1px 3px 0px rgba(16, 24, 40, 0.10), 0px 1px 2px 0px rgba(16, 24, 40, 0.06)',
  },
}));

export { useStyles };
